import Vue from "vue";
import apis from "@/config/api.config.js"
import qs from "qs";

import {
    DropdownMenu,
    DropdownItem,
    Dialog
} from 'vant';
import {
    Cell,
    CellGroup
} from 'vant';
import {
    Icon
} from 'vant';
import {
    Search
} from 'vant';
import {
    Toast
} from 'vant';
import {
    Button
} from 'vant';
import {
    Field
} from 'vant';

Vue.use(Field);
Vue.use(Button);
Vue.use(Search);
Vue.use(Icon);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);

export default {
    name: "index",
    data() {

        return {
            stars: [
                0, 0, 0, 0, 0
            ],
            star_cur: -1,
            saveBg: require('@/assets/savebg.jpg'),
            flagSprite: require('@/assets/flags.png'),
            flagAniIndex: 0,
            // flagSpriteSplit: [3, 2],
            flagSpriteSplit: [
                [0, 0],
                [1, 0],
                [2, 0],
                [0, 1],
                [1, 1],
                [2, 1],
            ],
            flagTop: .472 * document.body.offsetWidth,
            fps: 6,
            pause: false,
            now: null,
            then: Date.now(),
            // interval: 1000 / fps,
            delta: null,
            name:"",
            schoolname:"",
            gradename:"",
            certificateTime:"",
            certificateNumber:"",


        };
    },

    computed: {
        no_cert() {
            return this.star_cur == 4 ? false : true
        }
    },



    methods: {

        drawCertificate() {
            const that = this;
            let canvas = document.getElementById('cert-canvas');
            let ctx = canvas.getContext('2d');

            canvas.width = 750;
            canvas.height = 1334;



            let image = that.saveBgImg;
            ctx.drawImage(
                image,
                0,0,
                750,1334
            );

            ctx.save();

            ctx.fillStyle = "#c75252";
            ctx.font = "32px '微软雅黑'";
            ctx.textBaseline = "bottom";
            ctx.textAlign = "left";
            console.log(that.schoolname);
            ctx.fillText(that.schoolname, 60, 560);
            ctx.fillText(that.gradename + ' ' + that.name, 60, 610);

            ctx.restore();
            ctx.save();

            ctx.font = "32px '微软雅黑'";
            ctx.fillStyle = "#333";
            ctx.fillText("时间："+that.certificateTime, 440, 840)

            ctx.restore();
            ctx.save();

            ctx.fillStyle = "#c75252";
            ctx.font = "20px '微软雅黑'";
            ctx.fillText(that.certificateNumber, 530, 790)

            ctx.restore();

            let saveImg = document.createElement('img');
            saveImg.classList.add('saveImg');
            saveImg.src = canvas.toDataURL();
            document.getElementById("certificate").appendChild(saveImg);
        

        },


        getCertInfo(){
            const that = this;
            let toast = Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '加载中...',
            });
            let post_data = {
                token: localStorage.getItem('luoohutoken'),
            };
            that
                .axios({
                    method: "post",
                    // headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    // url: apis.getActivityList,
                    url: apis.getCertInfo,
                    data: qs.stringify(post_data),
                })
                .then((res) => {
                    console.log(res);
                    res = res.data;
                    if (res.code == 200) {
                        Toast.clear()
                        that.certificateTime = res.data.certtime;
                        that.certificateNumber = res.data.certid;
                        
                        let bg = new Image()
                        bg.src = that.saveBg
                        bg.onload = function() {
                            that.saveBgImg = bg
                            that.drawCertificate()
                        }
                        
                    }
                    else{
                        // userInfo:"深圳市罗湖区红湖小学 张三"; 
                    }
                })
                .catch((rej) => {
                    console.log(rej);
                }); 
        },
        getInfomation(){
            const that = this;
            let toast = Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '加载中...',
            });
            let post_data = {
                token: localStorage.getItem('luoohutoken'),
            };
            that
                .axios({
                    method: "post",
                    // headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    // url: apis.getActivityList,
                    url: apis.getInfomation,
                    data: qs.stringify(post_data),
                })
                .then((res) => {
                    console.log(res);
                    res = res.data;
                    if (res.code == 200) {
                        Toast.clear()
                        that.getCertInfo();
                        that.schoolname = res.data.schoolname;
                        that.gradename = res.data.gradename;
                        that.name = res.data.name;
                        
                    }
                    else{
                        // userInfo:"深圳市罗湖区红湖小学 张三"; 
                    }
                })
                .catch((rej) => {
                    console.log(rej);
                });  
        },
        tick() {
            const that = this;
            if (window.requestAnimationFrame) {
                let interval = 1000 / that.fps
                window.timer = requestAnimationFrame(that.tick)
                let now = Date.now()
                let delta = now - that.then
                if (delta > interval) {
                    that.then = now - (delta % interval)
                    if(document.getElementsByClassName('canvas').length) {
                        that.drawFlagWaved()
                    }
                    
                }
            }
        },
        toIndex() {
            cancelAnimationFrame(window.timer)
            this.$router.replace('/')

        },
        toCert() {
            cancelAnimationFrame(window.timer)
            this.$router.push('/certificate')
        },

        drawCanvas() {
            const that = this
            let container = document.getElementsByClassName('canvas')[0]
            let canvas = document.getElementById('canvas')
            canvas.width = container.offsetWidth
            canvas.height = container.offsetHeight
            let ctx = canvas.getContext('2d')


            that.drawFlagWaved(canvas, ctx)

        },

        // drawFlagWaved(canvas, ctx) {
        drawFlagWaved() {
            const that = this;
            // let fps = 60;
            // let pause = false;
            // let now;
            // let then = Date.now();
            // let interval = 1000/fps;
            // let delta;

            let container = document.getElementsByClassName('canvas')[0]
            let canvas = document.getElementById('canvas')
            if(container) {
                canvas.width = container.offsetWidth
                canvas.height = container.offsetHeight
                let ctx = canvas.getContext('2d')
    
                let aniindex = that.flagAniIndex;
                // let aniindex = 5;
                let index = that.flagSpriteSplit[aniindex];
                let image = that.flagImage;
                let flagWidth = image.width / 3;
                let flagHeight = image.height / 2;
                let flagTop = that.flagTop;
    
    
                ctx.save()
                ctx.clearRect(0, 0, flagWidth, flagHeight)
                ctx.drawImage(
                    image,
    
                    index[0] * flagWidth, index[1] * flagHeight,
    
                    flagWidth - 2, flagHeight,
    
                    .23 * canvas.width, flagTop,
    
                    .48 * flagWidth, .48 * flagHeight,
    
                )
    
                that.flagAniIndex++;
    
                if (that.flagAniIndex >= 6) {
                    that.flagAniIndex = 0
                }
                if (that.flagTop > 0) {
                    that.flagTop -= 2;
                } else {
                    that.flagTop = 0;
                }
                ctx.restore()
            }




            // requestAnimationFrame(that.drawFlagWaved)
            // requestAnimationFrame(that.drawFlagWaved(canvas, ctx))



        },
        drawFlagRised(ctx) {
            const that = this;

            console.log(that.flagAniIndex);
            // ctx.drawImage()

            that.flagAniIndex++;
            if (that.flagAniIndex >= 6) that.flagAniIndex = 0
            ctx.restore()
            // requestAnimationFrame(that.drawFlagRised(ctx))
        }

    },
    created() {
        const that = this;
        that.id = that.$route.query.id;
        that.type = that.$route.query.type;
        that.getInfomation();
    },
    mounted() {
        const that = this;

        let image = new Image()
        image.src = that.flagSprite
        image.onload = function () {
            that.flagImage = image
            // setInterval(() => {
                that.tick()
            // }, 1000 / that.fps);
            // that.tick()

        }


        

    },
    destroyed () {
        cancelAnimationFrame(window.timer)
    }

};